// extracted by mini-css-extract-plugin
export default {"wrapper":"vM-z","availablePromoMessagesLabel":"wM-z","promoMessageList":"xM-z","promoMessage":"yM-z","appliedPromoMessage":"zM-z","promoMessageAmount":"AM-z"};